import { Injectable } from '@angular/core'
import { CodeService } from '@core/code.service'

@Injectable()
export class StoreService {
   console: boolean = false
   logPrefix: string = '@core - ' + this.constructor.name

   private dataStorages: any = ['appStorage']

   private defaultStorage: string = 'appStorage'

   private appStorage: any = {}

   private tempData: any = {}

   constructor(public code: CodeService) {}

   isValidStorage(storage: string) {
      return storage && this.dataStorages.indexOf(storage) > -1
   }

   //-- appStorage --//

   appStorage_hasData(key: string) {
      return this.appStorage.hasOwnProperty(key)
   }

   appStorage_getData(key: string) {
      return this.appStorage[key]
   }

   appStorage_setData(key: string, val: any) {
      this.appStorage[key] = val
   }

   appStorage_removeData(key: string) {
      if (this.appStorage_hasData(key)) {
         delete this.appStorage[key]
         return true
      }
      return false
   }

   appStorage_getAll() {
      return this.appStorage
   }

   appStorage_clearAll() {
      this.appStorage = {}
      return true
   }

   //-- Store --//

   query(queryMethod: string, path: any, newValue?: any) {
      //if(this.console) console.log( this.logPrefix,  'query', queryMethod, path );

      let queryResponse = {
         result: null,
         error: null,
      }

      path = path.trim()

      // Set storage

      let storage = null

      let pathSplit = path.split(/\/(.+)/)

      let prefixSplit = pathSplit[0].split(':')
      if (prefixSplit.length > 1) {
         storage = prefixSplit[0].trim()

         if (!this.isValidStorage(storage)) {
            queryResponse.error = 'strorageNotValid'
            return queryResponse
         }
         pathSplit[0] = prefixSplit[1]
      }
      if (!storage) storage = this.defaultStorage

      //if(this.console) console.log( this.logPrefix,  'query - storage', storage );

      // Set dataKey

      let dataKey = pathSplit[0].trim()
      if (!dataKey || /\s/g.test(dataKey)) {
         // no whitespaces

         queryResponse.error = 'dataKeyNotValid'
         return queryResponse
      }

      //if(this.console) console.log( this.logPrefix,  'query - dataKey', dataKey);

      // Data check

      const dataKeyExists: boolean = this[storage + '_hasData'](dataKey)

      //if(this.console) console.log( this.logPrefix,  'query - dataKeyExists', dataKeyExists );

      const pathExists: boolean = pathSplit.length > 1

      //if(this.console) console.log( this.logPrefix,  'query - pathExists', pathExists );

      if (!pathExists) {
         // Method check

         //if(this.console) console.log( this.logPrefix,  'query - Method check', queryMethod);

         switch (queryMethod) {
            case 'HAS':
               queryResponse.result = dataKeyExists

               break
            case 'SET':
               this[storage + '_setData'](dataKey, newValue)
               queryResponse.result = true

               break
            case 'GET':
               if (dataKeyExists) {
                  queryResponse.result = this[storage + '_getData'](dataKey)
               } else {
                  queryResponse.error = 'notFound'
               }

               break
            case 'REMOVE':
               if (dataKeyExists) {
                  this[storage + '_removeData'](dataKey)
                  queryResponse.result = true
               } else {
                  queryResponse.error = 'notFound'
               }

               break
         }
      } else {
         // if pathExists

         path = pathSplit[1].trim()

         //if(this.console)  console.log( this.logPrefix,  'query - pathExists - path:', path );

         if (!path) {
            queryResponse.error = 'pathError'
            return queryResponse
         }

         // Set path for find

         let tempKey = null
         let findResult = null
         let findSuccess = false

         //if(this.console)  console.log( this.logPrefix,  'query - dataKeyExists:', dataKeyExists );

         if (dataKeyExists) {
            // find path

            if (this.console) console.log(this.logPrefix, 'query - Prepare Temp')

            // Prepare Temp Data

            tempKey = storage + '_' + dataKey

            if (this.tempData.hasOwnProperty(tempKey)) {
               // busy

               let dataBusy = true
               for (var i = 0; i < 3; i++) {
                  // retry

                  //if(this.console)  console.log( this.logPrefix,  "query - dataIsBusy retry", i );

                  this.code.sleep(2000) // waith

                  dataBusy = this.tempData.hasOwnProperty(tempKey)
                  if (!dataBusy) break //available
               }

               if (dataBusy) {
                  queryResponse.error = 'dataIsBusy'
                  return queryResponse
               }
            }

            this.tempData[tempKey] = this[storage + '_getData'](dataKey)

            // Find data by path

            findResult = this.code.findPath(this.tempData[tempKey], path)

            if (this.console) console.log(this.logPrefix, 'query - findResult', findResult)

            if (!findResult.error) findSuccess = true // find success

            //if(this.console)  console.log( this.logPrefix,  'query - findSuccess', findSuccess );
         }

         // Method check

         //if(this.console)  console.log( this.logPrefix,  'query - Method check', queryMethod);

         switch (queryMethod) {
            case 'HAS':
               queryResponse.result = findSuccess

               break
            case 'SET':
               if (findSuccess || (dataKeyExists && findResult.error == 'notFound')) {
                  // find OR add

                  findResult.pointer[findResult.target] = newValue
                  this[storage + '_setData'](dataKey, this.tempData[tempKey])
                  queryResponse.result = true
               } else {
                  queryResponse.error = 'notFound'
               } // on pathError

               break
            case 'GET':
               if (findSuccess) {
                  queryResponse.result = findResult.pointer[findResult.target]
               } else {
                  queryResponse.error = 'notFound'
               }

               break
            case 'REMOVE':
               if (findSuccess) {
                  delete findResult.pointer[findResult.target]
                  this[storage + '_setData'](dataKey, this.tempData[tempKey])
                  queryResponse.result = true
               } else {
                  queryResponse.error = 'notFound'
               }

               break
         }

         if (tempKey) delete this.tempData[tempKey] // clear temp
      }

      //if(this.console)  console.log( this.logPrefix,  'query - COMPLETE', queryResponse );

      return queryResponse
   }

   hasData(path: string) {
      if (this.console) console.log(this.logPrefix, 'hasData', path)

      return this.query('HAS', path)
   }

   setData(path: string, value: any) {
      if (this.console) console.log(this.logPrefix, 'setData', path, value)

      return this.query('SET', path, value)
   }

   getData(path: string) {
      if (this.console) console.log(this.logPrefix, 'getData', path)

      return this.query('GET', path)
   }

   removeData(path: string) {
      if (this.console) console.log(this.logPrefix, 'removeData', path)

      return this.query('REMOVE', path)
   }
}

